export default __webpack_public_path__ + "static/media/home_icon.ad567fb5.svg";